export default __webpack_public_path__ + "static/media/search.a27091ef.png";